import Movimentos from '@/views/admin/ods/movimentos'
import MovimentosImport from '@/views/admin/ods/movimentos/Import'

export const ods = [
  {
    path: 'ods',
    redirect: 'ods/movimentos',
    component: () => import('@/views/admin/ods'),
    children: [
      {
        path: 'movimentos',
        component: Movimentos,
        meta: {
          requiresAuth: true,
          userAuth: true
        },
      },
      {
        path: 'movimentos/import',
        component: MovimentosImport,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/ods.js